import type { ComponentType, SVGProps } from "react";
import { twMerge } from "tailwind-merge";

export type SuccessBannerProps = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  children: React.ReactNode;
  className?: string;
};

export const SuccessBanner = ({
  icon: Icon,
  children,
  className,
}: SuccessBannerProps) => (
  <div
    className={twMerge(
      "flex w-full animate-fade-in-up items-center gap-2 rounded-md bg-success-25 px-4 py-3 text-sm text-success-primary motion-reduce:animate-none",
      className,
    )}
  >
    <Icon className="size-4 shrink-0" />
    <p className="flex-1">{children}</p>
  </div>
);
